import { h, useState, useEffect, useRef } from 'preact'
import style from 'utils/style'
import { decode } from 'utils/dom'
import translate from 'core/hooks/useResource'
import FooterNetworks from './FooterNetworks'

export default function CompanyInfo({
    storeName,
    about,
    email,
    address,
    phone,
    socialSettings,
}) {
    const companyInfo = style(`company-info`)

    return (
        <section className={companyInfo()}>
            <span className={companyInfo(`title`)}>{storeName}</span>
            <p className={companyInfo(`about`)}>{about}</p>
            
            <div className={companyInfo(`address`)}>
                <span style={{ marginTop: '5px' }}><strong>{decode(translate('footer.findus'))}</strong>{decode(address)}</span>
                <span><strong>{decode(translate('footer.email'))}</strong>{email}</span>
                <span style={{ marginBottom: '5px' }}><strong>{decode(translate('footer.phone'))}</strong>{phone}</span>
            </div>

       
            <FooterNetworks {...socialSettings} />
        </section>
    )
}